/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class BillingInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billingInfo: {},
            isEditing: {
                billingContact: false,
                billingAddress: false
            },
            isSaving: {
                billingContact: false,
                billingAddress: false
            },
            contactErrors: null,
            addressErrors: null,
        };

        this.onBeginEdit = this.onBeginEdit.bind(this);
        this.onCancelEdit = this.onCancelEdit.bind(this);
        this.updateEditingState = this.updateEditingState.bind(this);
        this.updateBillingInfo = this.updateBillingInfo.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.loadStates = this.loadStates.bind(this);
        this.updatePayment = this.updatePayment.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = [];

        errors = props.getApiErrors(['SUB_FETCH', 'SUB_FETCH_BILLING', 'SUB_UPDATE_BILLING']);

        if (errors.length) {
            if (state.isSaving.billingContact) {
                nextState.contactErrors = errors[0];
            } else if (state.isSaving.billingAddress) {
                nextState.addressErrors = errors[0];
            }

            nextState.isSaving = {
                billingContact: false,
                billingAddress: false
            };

        } else if (errors.length === 0 && !_.isEmpty(state.errors)) {
            nextState.contactErrors = null;
            nextState.billingErrors = null;
        }

        return (Object.keys(nextState).length) ? nextState : null;
    }


    componentDidMount() {
        let constants = this.props.app.config.constants;

        if (this.props.isFreeUser()) {
            this.props.router.navigate('/account/subscription/new');
        }

        this.props.getPlans();
        this.props.getBillingInfo();
        this.props.getCountries();
        this.props.getSubscription();

        if (this.props.router.query && this.props.router.query.update) {
            this.updatePayment();
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (_.isEmpty(this.state.billingInfo) && !_.isEmpty(this.props.plans.billingInfo)) {
            this.setState({
                billingInfo: this.props.plans.billingInfo
            });
        }


        if (this.state.addressErrors === null &&
            this.state.contactErrors === null &&
            prevProps.app.loading.SUB_UPDATE_BILLING === true && this.props.app.loading.SUB_UPDATE_BILLING === false) {
            let errors = this.props.getApiErrors(['SUB_UPDATE_BILLING']);
            if (!errors.length) {
                this.props.closeAllModals();
            }
            this.setState({
                billingInfo: this.props.plans.billingInfo,
                isEditing: {
                    billingContact: false,
                    billingAddress: false
                },
                isSaving: {
                    billingContact: false,
                    billingAddress: false
                }
            });
        }

    }

    onBeginEdit(e) {

		let section = e.currentTarget.dataset.section;

		this.updateEditingState(section, true);

	}

	onCancelEdit(e) {

		let section = e.currentTarget.dataset.section,
			billingInfo = this.state.billingInfo,
            addressErrors = this.state.addressErrors,
            contactErrors = this.state.contactErrors;

		this.updateEditingState(section, false);

        if (section === 'billingContact') {
            contactErrors = null;
        } else if (section === 'billingAddress') {
            addressErrors = null;
        }

		// reset the value
		billingInfo = _.clone(this.props.plans.billingInfo);

		this.setState({
			billingInfo,
            addressErrors,
            contactErrors
		});

	}

	updateEditingState(key, state) {

		let isEditing = this.state.isEditing;

		isEditing[key] = state;

		this.setState({
			isEditing
		});

	}

    updateBillingInfo(e) {

        let section = e.currentTarget.dataset.section,
            isSaving = this.state.isSaving;

        this.props.updateBillingInfo(this.state.billingInfo);

        isSaving[section] = true;

        this.setState({
            isSaving
        });

    }

    onCountryChange(e) {

        let billingInfo = this.state.billingInfo,
            country = e.currentTarget.value;

        if (country) {
            this.props.getRegions(country);
            billingInfo.country = country;
        }

        this.setState({
            billingInfo
        });

    }

    loadStates() {

        if (this.state.billingInfo.country) {
            this.props.getRegions(this.state.billingInfo.country);
        }

    }

    updatePayment() {

        let ccModal = null,
            first = '',
            last = '',
            parts = [];

        if (this.state.billingInfo.firstName && this.state.billingInfo.lastName) {
            first = this.state.billingInfo.firstName;
            last = this.state.billingInfo.lastName;
        } else {
            parts = this.props.user.detail.username.split("@");
            first = parts[0];
            last = parts[1];
        }

        ccModal = (
            <CreditCardModal
                {...this.props}
                plan={this.props.user.detail.pubLevel}
                planTerm={this.props.plans.current.planTerm}
                planPrice={this.props.plans.current.price}
                firstName={first}
                lastName={last}
                router={this.props.router}
                closeAction={this.props.closeAllModals}
                action='update'
                heading={"Update your Payment Info"}
                version={1}
                errors={this.state.errors} />
        );

        this.props.addModal(ccModal)

    }


    render() {
        let header = null,
            content = null,
            paymentBlock = null,
            billingBlock = null,
            addressBlock = null,
            waitingBlock = null,
            billingSave = null,
            addressSave = null,
            stateSelector = null,
            firstName = (this.state.billingInfo && this.state.billingInfo.firstName) ? this.state.billingInfo.firstName : '',
            lastName = (this.state.billingInfo && this.state.billingInfo.lastName) ? this.state.billingInfo.lastName : '',
            email = (this.state.billingInfo && this.state.billingInfo.email) ? this.state.billingInfo.email : '',
            companyName = (this.state.billingInfo && this.state.billingInfo.companyName) ? this.state.billingInfo.companyName : '',
            address1 = (this.state.billingInfo && this.state.billingInfo.address1) ? this.state.billingInfo.address1 : '',
            address2 = (this.state.billingInfo && this.state.billingInfo.address2) ? this.state.billingInfo.address2 : '',
            city = (this.state.billingInfo && this.state.billingInfo.city) ? this.state.billingInfo.city : '',
            zip = (this.state.billingInfo && this.state.billingInfo.zip) ? this.state.billingInfo.zip : '',
            vatNumber = (this.state.billingInfo && this.state.billingInfo.vat_number) ? this.state.billingInfo.vat_number : '',
            phone = (this.state.billingInfo && this.state.billingInfo.phone) ? this.state.billingInfo.phone : '';

        const displayError = (errors) => {
            let keys = Object.keys(errors),
                errorMsgs = [];
            if (keys.length) {
                keys.map((key) => {
                    errorMsgs.push(errors[key]);
                });
            }
            return (
                <div className="fieldset-error">
                    <ul className="fieldset-error-list">
                        {errorMsgs.map((msg, i) => {
                            return (
                                <li key={`error-${i}`} className="error-list-item">
                                    {msg}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        };


        if (this.props.user && this.props.user.detail.isAgent) {
            let subaccount = <EmptyState message={"Sorry, only the account owner can access this page."}/>
            return (
                <Content header={header} main={subaccount}/>
            );
        }

        if (this.props.app.loading.SUB_FETCH_BILLING || _.isEmpty(this.state.billingInfo) || this.props.app.loading.SUB_FETCH_PLANS) {
            waitingBlock = (
                <Loading/>
            );
            return (<Content header={header} main={waitingBlock}/>);
        }

        header = (
            <div className="content-header white">
                <div className="account-header">Your Billing Information</div>
            </div>
        );

        if (this.state.billingInfo.payment.type === 'paypal') {
            paymentBlock = (
                <div>
                    <strong>Paypal Agreement:</strong> {this.state.billingInfo.payment.agreement}
                </div>
            )
        } else {
            paymentBlock = (
                <div>
                    <strong>{this.state.billingInfo.payment.cardType}</strong> ending in {this.state.billingInfo.payment.last} expiring {this.state.billingInfo.payment.month}/{this.state.billingInfo.payment.year}
                </div>
            )
        }

        if (this.props.utilities.regions.length) {
            let stateValue = this.state.billingInfo.state;
            if (this.props.utilities.regions[this.state.billingInfo.state] === undefined) {
                for (let i = 0; i < this.props.utilities.regions.length; ++i) {
                    if (this.props.utilities.regions[i].label === this.state.billingInfo.state) {
                        stateValue = this.props.utilities.regions[i].value;
                        break;
                    }
                }
            }
            stateSelector = (
                <StyledSelect
                    options={this.props.utilities.regions}
                    linkedField="billingInfo.state"
                    value={stateValue}
                    selectClass="state-dd full"
                    onChange={FormUtilityMixin.requestChange.bind(this)} />
            )
        }

        let contactErrors = null,
            addressErrors = null;

        if (this.state.contactErrors !== null) {
            contactErrors = displayError(this.state.contactErrors.errors);
        }

        if (this.state.addressErrors !== null) {
            addressErrors = displayError(this.state.addressErrors.errors);
        }

        if (this.state.isEditing.billingContact) {
            if (this.state.isSaving.billingContact) {
                billingSave = <i className="fa fa-cog fa-spin"></i>;
            } else {
                billingSave = "save";
            }
            billingBlock = (
                <div>
                    <div className="edit-block billing">
                        {contactErrors}
                        <div className="field-wrapper edit">
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input medium inline" placeholder="First Name" defaultValue={firstName} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.firstName"/>
                                <UncontrolledTextInput className="text-input medium inline" placeholder="Last Name" defaultValue={lastName} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.lastName"/>
                            </div>
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input large inline" placeholder="Billing Email" defaultValue={email} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.email"/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons">
                        <div className="cancel-button" onClick={this.onCancelEdit} data-section="billingContact"  role='button' aria-label="cancel contact edit">
                            cancel
                        </div>
                        <div className="edit-save" onClick={this.updateBillingInfo} data-section="billingContact" role='button' aria-label="save contact edit">
                            {billingSave}
                        </div>
                    </div>
                </div>
            );
        } else {
            billingBlock = (
                <div className="display-block">
                    <div className="account-display field-wrapper">
                        <div className="field-block">
                            {this.state.billingInfo.firstName} {this.state.billingInfo.lastName}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.email}
                        </div>
                    </div>
                    <div className="edit-button" onClick={this.onBeginEdit} data-section="billingContact" role='button' aria-label="edit contact">
                        <i className="fa fa-pencil"></i>
                    </div>
                </div>
            );
        }

        if (this.state.isEditing.billingAddress) {
            if (this.state.isSaving.billingAddress) {
                addressSave = <i className="fa fa-cog fa-spin"></i>;
            } else {
                addressSave = "save";
            }
            addressBlock = (
                <div>
                    <div className="edit-block billing">
                        {addressErrors}
                        <div className="field-wrapper">
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input large inline" placeholder="Company Name" defaultValue={companyName} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.companyName"/>
                            </div>
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input large inline" placeholder="Address 1" defaultValue={address1} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.address1"/>
                            </div>
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input large inline" placeholder="Address 2" defaultValue={address2} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.address2"/>
                            </div>
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input medium inline" placeholder="City" defaultValue={city} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.city"/>
                                <UncontrolledTextInput className="text-input medium inline" placeholder="Postal Code" defaultValue={zip} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.zip"/>
                            </div>
                            <div className="field-block">
                                {stateSelector}
                            </div>
                            <div className="field-block">
                                <StyledSelect
                                    options={this.props.utilities.countries}
                                    linkedField="billingInfo.country"
                                    value={this.state.billingInfo.country}
                                    selectClass="country-dd full"
                                    onChange={this.onCountryChange}
                                    onMount={this.loadStates} />
                            </div>
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input large inline" placeholder="Phone" defaultValue={phone} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.phone"/>
                            </div>
                            <div className="field-block">
                                <UncontrolledTextInput className="text-input large inline" placeholder="VAT Number" defaultValue={vatNumber} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="billingInfo.vat_number"/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons">
                        <div className="cancel-button" onClick={this.onCancelEdit} data-section="billingAddress" role='button' aria-label="cancel address edit">
                            cancel
                        </div>
                        <div className="edit-save" onClick={this.updateBillingInfo} data-section="billingAddress" role='button' aria-label="save address edit">
                            {addressSave}
                        </div>
                    </div>
                </div>
            );
        } else {
            addressBlock = (
                <div className="display-block">
                    <div className="account-display field-wrapper">
                        <div className="field-block">
                            {this.state.billingInfo.companyName}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.address1}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.address2}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.city} {this.state.billingInfo.state} {this.state.billingInfo.zip}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.country}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.vat_number}
                        </div>
                        <div className="field-block">
                            {this.state.billingInfo.phone}
                        </div>
                    </div>
                    <div className="edit-button" onClick={this.onBeginEdit} data-section="billingAddress" role='button' aria-label="edit address">
                        <i className="fa fa-pencil"></i>
                    </div>
                </div>
            )
        }

        content = (
            <div className="editor-panel alt">
                <fieldset className="alt">
                    <legend>Payment Method</legend>
                    <div className="display-block">
                        <div className="account-display">
        					{paymentBlock}
                        </div>
                        <div className="payment-update" onClick={this.updatePayment} role='button' aria-label="update billing details">
                            Update Billing Details
                        </div>
                    </div>
                </fieldset>
                <fieldset className="alt">
                    <legend>Billing Contact</legend>
                    {billingBlock}
                </fieldset>
                <fieldset className="alt">
                    <legend>Billing Address</legend>
                    {addressBlock}
                </fieldset>
            </div>
        );

        return (
            <Content header={header} main={content} />
        );
    }

};

BillingInfo.displayName = "BillingInfo";

export default ComponentWithContext(BillingInfo);
